<template>
  <common-card class="mt-3">
    <v-row>
      <v-col>
        <v-row style="padding: 15px 20px 0px 20px">
          <v-col cols="12" md="6">
            <h1>Administrador de Alianzas Inter.mx</h1>
          </v-col>
          <v-col cols="12" md="6" style="text-align: end">
            <v-btn
              class="common-botton"
              dark
              :loading="loading"
              @click="$router.push('/administracion/alianzas-intermx/crear')"
            >
              <v-icon class="mr-2">mdi-plus</v-icon>
              <span>Nueva</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- Expansion Panel para Búsqueda detallada -->
    <v-expansion-panels
      elevation="0"
      style="padding: 30px; border-radius: 20px"
    >
      <v-expansion-panel>
        <v-expansion-panel-header style="padding: 35px">
          <h3 style="color: #42352e">Búsqueda detallada</h3>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row>
            <v-col cols="4">
              <v-autocomplete
                v-model="filtros.status"
                label="Estatus"
                :items="statusAlianzas"
                item-text="value"
                item-value="id"
                outlined
                dense
                color="primary"
                background-color="white"
              ></v-autocomplete>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="filtros.nombreAlianza"
                label="Nombre de la alianza"
                outlined
                dense
                color="primary"
                background-color="white"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="filtros.responsable"
                label="Responsable de la alianza"
                outlined
                dense
                color="primary"
                background-color="white"
              ></v-text-field>
            </v-col>
          </v-row>

          <!-- Botones alineados a la derecha -->
          <v-row style="padding: 0px 40px 0px 40px" class="d-flex justify-end">
            <v-col cols="12" md="2">
              <v-btn
                dark
                block
                outlined
                color="#00a7e4"
                rounded
                @click="limpiarFiltros()"
              >
                Limpiar
              </v-btn>
            </v-col>
            <v-col cols="12" md="2" style="text-align: end">
              <v-btn
                class="common-botton"
                dark
                block
                :loading="loading"
                @click="getAlianzas()"
              >
                <span>Filtrar</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <div style="padding: 0px 40px 0px 40px">
      <hr />
    </div>

    <!-- Tabla de resultados -->
    <v-row>
      <v-col cols="12" class="mb-10" style="padding: 40px">
        <v-data-table
          style=""
          :headers="headers"
          @pagination="pagination"
          :server-items-length="totalItems"
          :items="alianzas"
          item-key="id"
          class="elevation-0"
          :loading="loading"
          loading-text="Cargando..."
          no-data-text="Para ver elementos, primero realiza una búsqueda"
        >
          <template v-slot:top>
            <v-row style="padding: 15px">
              <v-col cols="8">
                <h2>Resultados de la búsqueda</h2>
              </v-col>
            </v-row>
          </template>

          <template v-slot:item.fecha_inicio="{ item }">
            <span>
              {{
                item.fecha_inicio
                  ? cleanDate(item.fecha_inicio)
                  : "No especificado"
              }}
            </span>
          </template>

          <template v-slot:item.status="{ item }">
            <div>
              <v-chip :color="getStatusColor(getStatusLabel(item.status))" dark>
                {{ getStatusLabel(item.status) }}
              </v-chip>
            </div>
          </template>

          <template v-slot:item.ver="{ item }">
            <v-icon small class="mr-2" @click="goToAlianzaDetail(item.id)">
              mdi-eye
            </v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </common-card>
</template>

<script>
import { mainAxios } from "../../../../../mainAxios";
import CommonCard from "@/components/commonComponents/CommonCard.vue";
import moment from "moment";

export default {
  name: "AdministradorAlianzasIntermx",
  components: {
    CommonCard,
  },
  data() {
    return {
      moment,
      statusAlianzas: [
        { id: 1, value: "Activo" },
        { id: 2, value: "Inactivo" },
        { id: 3, value: "Baja" },
      ],
      headers: [
        {
          text: "ID",
          align: "start",
          sortable: false,
          value: "id",
        },
        {
          text: "Nombre de la Alianza",
          sortable: false,
          value: "nombre",
        },
        {
          text: "Status",
          value: "status",
        },
        {
          text: "Inicio de la operación",
          value: "fecha_inicio",
        },
        {
          text: "Responsable",
          value: "nombreResponsable",
          sortable: false,
        },
        {
          text: "Ver",
          value: "ver",
          sortable: false,
        },
      ],
      totalItems: 0,
      filtros: {
        nombreAlianza: null,
        responsable: null,
        status: null,
        pagina: 1,
        elementosPagina: 10,
      },
      rol: JSON.parse(localStorage.getItem("roles"))[0].rol,
      roles: JSON.parse(localStorage.getItem("roles")),
      loading: false,
      alianzas: [],
    };
  },

  //   computed: {
  //     filtersIncomplete() {
  //       return (
  //         !this.filtros.nombreAlianza &&
  //         !this.filtros.responsable &&
  //         !this.filtros.status
  //       );
  //     },
  //   },

  mounted() {
    // Se puede descomentar esto si quieres cargar datos al inicio de la pagina
    // this.getAlianzas();
  },

  methods: {
    getAlianzas() {
      this.loading = true;
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.agenteAccessToken,
        },
      };

      const filtrosLimpios = Object.fromEntries(
        Object.entries(this.filtros).filter(
          ([, valor]) => valor !== "" && valor !== null && valor !== undefined,
        ),
      );

      let url = `/v1/alianzasintermx/filtros/list`;

      mainAxios
        .post(url, filtrosLimpios, config)
        .then((response) => {
          this.alianzas = response.data.data.alianzas;
          this.totalItems = response.data.data.numRegisters;
        })
        .catch((error) => {
          console.error("Error al obtener alianzas:", error);
          this.$toast.error("Error al cargar las alianzas", {
            position: "top-right",
            timeout: 3000,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    goToAlianzaDetail(id) {
      this.$router.push(`/administracion/alianzas-intermx/ver/${id}`);
    },

    pagination(event) {
      console.log("Pagination event:", event);
    },

    getStatusColor(status) {
      const statusColors = {
        Activo: "green",
        Inactivo: "amber darken-2",
        Baja: "red",
      };
      return statusColors[status] || "grey";
    },

    limpiarFiltros() {
      this.filtros = {
        status: null,
        nombreAlianza: null,
        responsable: null,
        pagina: 1,
        elementosPagina: 10,
      };

      this.alianzas = [];
      this.totalItems = 0;
    },

    getStatusLabel(statusId) {
      const obj = this.statusAlianzas.find((s) => s.id === statusId);
      return obj && obj.value ? obj.value : "Desconocido";
    },

    cleanDate(fechaString) {
      const date = new Date(fechaString);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    },
  },
};
</script>

<style scoped>
.theme--light.v-data-table {
  background-color: #f2fafc;
  color: rgba(0, 0, 0, 0.87);
  border-radius: 20px;
}

.v-expansion-panel {
  border-radius: 20px;
}

.v-expansion-panels {
  z-index: auto !important;
}

.v-expansion-panels:not(.v-expansion-panels--accordion):not(.v-expansion-panels--tile)
  > .v-expansion-panel--active {
  border-radius: 20px !important;
}

.theme--light.v-expansion-panels .v-expansion-panel {
  background-color: #f6f5f9;
  color: rgba(0, 0, 0, 0.87);
}

.common-botton {
  background-color: #00a7e4 !important;
}

.v-chip.v-size--default {
  height: auto;
  width: 70px;
  display: flex;
  justify-content: center;
}
</style>
